import { render, staticRenderFns } from "./PostComposer.vue?vue&type=template&id=b6cb6cd6&scoped=true&"
import script from "./PostComposer.vue?vue&type=script&lang=js&"
export * from "./PostComposer.vue?vue&type=script&lang=js&"
import style0 from "./PostComposer.vue?vue&type=style&index=0&id=b6cb6cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb6cd6",
  null
  
)

export default component.exports